module.exports = __webpack_public_path__ + "img/full4-min.cd238c0e.png";